import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Select, Store } from '@ngxs/store';
import { Observable, lastValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';
import { SnappstayState } from 'src/app/state/snappstay.state';
import { Authorize } from 'src/app/models/authorize.model';
import { UserRegestrationResponse } from 'src/app/models/response-model/user-regestration-response-model';
import { UserProfile } from 'src/app/models/user-profile.model';
import { Login, SetBookingRequest, SetUserProfile } from 'src/app/state/snappstay.action';
import { AccountsApiService } from 'src/app/services/api-services/accounts-api';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class AuthFacadeService {
  @Select(SnappstayState.Authorize)
  authorize$!: Observable<Authorize>;

  @Select(SnappstayState.GetUser)
  user$!: Observable<UserRegestrationResponse>;

  @Select(SnappstayState.GetUserProfile)
  userProfile$!: Observable<UserProfile>;

  // Derived role stream so components do not need to compute it themselves
  role$ = this.authorize$.pipe(map((auth: any) => auth?.roles?.[0] ?? 'Guest'));

  isAdministrator$ = this.role$.pipe(map((role) => role === 'Administrator'));
  isHost$ = this.role$.pipe(map((role) => role === 'Host'));
  isGuest$ = this.role$.pipe(map((role) => role === 'Guest'));

  constructor(
    private store: Store,
    private accountApiService: AccountsApiService,
    private toastr: ToastrService,
    private router: Router,
  ) {}

  async loadUserProfile(): Promise<void> {
    try {
      const getMyProfile$ = this.accountApiService.GetMyProfile();
      const getMyProfile = await lastValueFrom(getMyProfile$, {
        defaultValue: undefined,
      });
      if (getMyProfile) {
        this.store.dispatch(new SetUserProfile(getMyProfile));
      }
    } catch (e: any) {
      let message = 'SOMETHING_WENT_WRONG_TRY_AGAIN';
      if (e?.error) {
        message = e.error.message ? e.error.message : e.error.errors[0];
        this.toastr.error(message, 'Please try again later', {
          timeOut: 3000,
          positionClass: 'toast-bottom-right',
        });
      }
    }
  }

  logOut(): void {
    this.store.dispatch(new SetBookingRequest(null));
    this.store.dispatch(new Login(undefined));
    this.store.reset({});
    localStorage.clear();
    this.router.navigate(['/']).then();
  }
}
